export class ModuloModel {
    Id: number;
    Nombre: string;
    Observaciones: string;
    Opciones: ModuloOptionsModel[] = [];
    FechaAlta: Date;
    FechaModificacion: Date;
    FechaBaja: Date;
}

export class ModuloOptionsModel {
    Id: number;
    ModuloId: number;
    PadreId?: number;
    Orden: number;
    TextoId: string;
    AccionId: string;
    SoloMovisat: boolean;
    Observaciones?: string;
    OpcionOriginalId?: number;

    // Agregados
    Level: number;

    constructor(id: number, moduloId: number, padreId: number, orden: number,
        textoId: string, accionId: string, soloMovisat: boolean, observaciones: string, level: number, idOriginal: number) {
        this.Id = id;
        this.ModuloId = moduloId;
        this.PadreId = padreId;
        this.Orden = orden;
        this.TextoId = textoId;
        this.AccionId = accionId;
        this.SoloMovisat = soloMovisat;
        this.Observaciones = observaciones;
        this.Level = level;
        this.OpcionOriginalId = idOriginal;
    }

}

export class ModuloAppEmpModel {
    Id: number;
    AplicacionId: number;
    ModuloId: number;
    EmpresaId: number;
    Modulo: ModuloModel;
}

